module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/main-visual-79dd7d7d334e7a6e1ae24c73f094dc7f.jpg";